'use client';
import React from "react";
import { useReveal } from "@/components/Reveal/useReveal";
import reveal from "@/components/Reveal/reveal.module.scss";
import VadImage from "vadimages-nextjs-image-optimizer";

interface IGanjierMobileVideoThumbnailProps {
    onClick: () => void;
    id: number;
    imageDirectory: string;
}

const GanjierMobileVideoThumbnail = ({ onClick, id, imageDirectory }: IGanjierMobileVideoThumbnailProps) => {
    // Was framer-motion (opacity fade-in). Now CSS reveal: fades in on scroll into view.
    const { ref, shown } = useReveal<HTMLDivElement>();

    return <div
        ref={ref}
        className={`w-fit ${reveal.reveal} ${shown ? reveal.shown : ''}`}>
        <div className={`video-link video-corners w-fit mx-auto`} onClick={onClick}>
            <figure>
                <VadImage
                    src={`${imageDirectory}/mobile/ganjier-thumb-${id + 1}.png`}
                    width={200}
                    height={357}
                    alt={`Ganjier-${id + 1}`}
                />
            </figure>
        </div>
    </div>
}

export default GanjierMobileVideoThumbnail;
